// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/Delivery.css
// module id = 181
// module chunks = 0